module.exports = __webpack_public_path__ + "img/main10.70e59436.jpg";